<template>
    <div :class="[$store.state.layout_style, $store.state.menu_style]">
        <component v-bind:is="layout"></component>
    </div>

    <!-- import global component -->
    <AddtopicModal></AddtopicModal>
    <NewsdetailModal></NewsdetailModal>
    <LoadingModal></LoadingModal>
    <LoginModal></LoginModal>
    <CoinModal></CoinModal>
    <CoinTransferModal></CoinTransferModal>
    <CoinTransferConfirmModal></CoinTransferConfirmModal>
    <RedeemDetailModal></RedeemDetailModal>
    <RedeemDetailComfrimModal></RedeemDetailComfrimModal>
    <ReporterDetailAddNewsModal></ReporterDetailAddNewsModal>
    <ReporterDetailModal></ReporterDetailModal>
    <PersonaModal></PersonaModal>
    <FollowerListModal></FollowerListModal>
    <ReporterDetailVDOModal></ReporterDetailVDOModal>
    <surveyInfoModal></surveyInfoModal>
    <AnnounceModal></AnnounceModal>
    <CoinTransferHistoryModal></CoinTransferHistoryModal>
    <NewsbroadcastInfoModal></NewsbroadcastInfoModal>
</template>
<script setup>
    import { computed } from 'vue';

    import '@/assets/sass/app.scss';

    import { useMeta } from '@/composables/use-meta';
    import { useStore } from 'vuex';
    
    useMeta({ title: 'Incident' });

    const store = useStore();

    const layout = computed(() => {
        return store.getters.layout;
    });
</script>
<script>
    // layouts
    import appLayout from './layouts/app-layout.vue';
    import authLayout from './layouts/auth-layout.vue';

    export default {
        components: {
            app: appLayout,
            auth: authLayout,
        },
    };
</script>